import React, { useEffect, useState } from "react";
import { Box, Typography, keyframes } from "@mui/material";
import logo from "../assets/Logo.png";

// أنميشنات
const pulse = keyframes`
  0% { opacity: 0.7; transform: scale(0.9); }
  50% { opacity: 1; transform: scale(1.05); }
  100% { opacity: 0.9; transform: scale(1); }
`;

const bounce = keyframes`
  0%, 80%, 100% { transform: scale(0); }
  40% { transform: scale(1); }
`;

const LoadingComponent = () => {
  // 🔁 جمل متغيرة
const messages = [
  "جهزنا لك أفضل تجربة تسوّق 🛍️",
  "نرتّب لك العروض الحصرية 🔥",
  "نجمع لك المنتجات المميزة…",
  "بعد لحظات بنقدّم لك أحدث العروض 📦",
  "نجهز عربيتك… استعد للشراء! 🛒",
  "نضبط الصفحة لكي تصير مثالية ✨",
  "لحظة… نفتّح لك باب التوفير 💸",
  "انتظر شوي… الجمال يحتاج تجهيز 😍",
  "قرّبنا نوصل… اربط الحزام 🚀",
];


  const [msgIndex, setMsgIndex] = useState(0);

  // ⏱️ تغيير كل 3 ثواني
  useEffect(() => {
    const interval = setInterval(() => {
      setMsgIndex((prev) => (prev + 1) % messages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // bgcolor: "#f9f9f9",
        flexDirection: "column",
      }}
    >
      {/* الشعار */}
      <Box
        component="img"
        src={logo}
        alt="App Logo"
        sx={{
          width: 100,
          height: 100,
          animation: `${pulse} 1.5s ease-in-out infinite`,
          // filter: `drop-shadow(0 4px 12px rgba(0, 0, 0, 0.15))`,
        }}
      />

      {/* النقاط */}
      <Box sx={{ display: "flex", gap: 1, mt: 3, mb: 2 }}>
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: "primary.main",
              animation: `${bounce} 1.4s infinite ease-in-out`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </Box>

      {/* النص المتغير */}
      <Typography
        variant="body1"
        sx={{ fontWeight: 500, color: "#555", transition: "0.3s" }}
      >
        {messages[msgIndex]}
      </Typography>
    </Box>
  );
};

export default LoadingComponent;
